import { defineMessages } from 'react-intl';

export default defineMessages({
  passwordTooWeak: {
    id: 'app.components.Form.Fieldset.passwordTooWeak',
    defaultMessage: 'too weak',
  },
  passwordOkay: {
    id: 'app.components.Form.Fieldset.passwordOkay',
    defaultMessage: 'okay',
  },
  passwordGood: {
    id: 'app.components.Form.Fieldset.passwordGood',
    defaultMessage: 'good',
  },
  passwordStrong: {
    id: 'app.components.Form.Fieldset.passwordStrong',
    defaultMessage: 'strong',
  },
});
